import cx from 'classnames';
import { FC } from 'react';

import { t } from '@core/i18n';
import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { Alert, AlertType } from '@shared/components/alert';
import { Button } from '@shared/components/button-new';
import { CompanyFormData } from '@shared/components/create-update-contact/CreateUpdateContact.types';
import { Ellipsis } from '@shared/components/ellipsis';
import { Flex } from '@shared/components/flex';
import { TextField } from '@shared/components/text-field';
import { Company } from '@shared/models/company/company';
import { ButtonColour } from '@shared/types/common/button';

import { styles } from './MatchedCompanies.styles';

export interface MatchedCompaniesProps extends WithStyles<typeof styles> {
  inputs: CompanyFormData;
  handleFormChange: ChangeCallback<CompanyFormData>;
  handleReturn: () => void;
  companies: Company[];
  handleSelect: (value: Company) => () => void;
}

const MatchedCompaniesComponent: FC<MatchedCompaniesProps> = ({
  classes,
  handleReturn,
  inputs,
  handleFormChange,
  companies,
  handleSelect,
}) => {
  return (
    <div className={classes.content}>
      <div className={classes.block}>
        <span className={classes.blockTitle}>{t('company_details')}</span>
        <Flex alignItems="center" wrap="nowrap" classes={{ root: classes.row }}>
          <div className={classes.fullRowElement}>
            <span className={classes.label}>{t('xtextx_asterisk', { text: t('company_name') })}</span>
            <TextField
              disabled
              value={inputs.name}
              onChange={(e) => handleFormChange('name')(e.target.value)}
              fullWidth
              placeholder="Google"
            />
          </div>
        </Flex>
      </div>
      <div className={classes.block}>
        <span className={classes.blockTitle}>{t('similar_companies')}</span>
        <Alert
          type={AlertType.warning}
          icon={<i className={`icon icon-alert-triangle ${classes.icon}`} />}
          message={t(
            'the_matches_are_based_upon_the_company_called_xcompanyx_that_you_entered_check_below_that_the_listed_companies_are_the_company_that_you_are_trying_to_create_if_so_please_select_or_continue_back_to_create_form',
            { company: inputs.name }
          )}
          title={t('weve_found_some_possible_matches')}
        />
        <div className={cx(classes.block, classes.fullRowElement)}>
          {companies.map((company: Company) => (
            <Flex key={company.id} alignItems="center" className={classes.selectElement} wrap="nowrap">
              <Flex autoWidth={false} className={classes.selectElementInfo}>
                <Ellipsis classes={{ root: classes.selectElementName }} text={company.name} />
                <span className={classes.selectElementAddress}>{company.address1 || '-'}</span>
              </Flex>
              <Button text={t('select')} onClick={handleSelect(company)} />
            </Flex>
          ))}
        </div>
        <Flex autoWidth={false} alignItems="center" justifyContent="center" classes={{ root: classes.matchesFooter }}>
          <Button text={t('continue_creating_new_company')} colour={ButtonColour.primary} onClick={handleReturn} />
        </Flex>
      </div>
    </div>
  );
};

export const MatchedCompanies = withStyles(styles)(MatchedCompaniesComponent);
